
export const isMobile = () => (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || 
    window.matchMedia('(max-width: 768px)').matches
)

export const isLowQuality = () => {
    if (navigator.hardwareConcurrency) {
        return navigator.hardwareConcurrency <= 2
    } if (isMobile()) {
        return true
    }
    return false
}
